module.exports = __webpack_public_path__ + "img/habyt.a585eb4d.svg";